import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text, FlatList } from 'react-native';
import ActivityIndicator from '../components/ActivityIndicator';
import { ListItem } from '../components/lists';
import configurationPost from '../config/configurationPost';
import connectionConfig from "../config/settings";
import routes from '../navigation/routes';


function FollowersScreen(props) {
    useEffect(() => {
        debugger
        getFollowers()
    }, []);
const [items, setItems] = useState([]) 
const [loading, setLoading] = useState(false);
const [followers, setFollowers] = useState(0);

const getFollowers = async () => {
    setLoading(true)
    var post_values = {
       userId : props.route.params.userId
    }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectFollower/', configurationPost)
   .then(response => response.json())
   .then(response => {
       //debugger
    setItems(response.data) 

    if( response.data.length  ===  0 ){       
        setFollowers(1) 
    }

   setLoading(false)
   })
   .catch(err =>{
   console.log('Failed :( review internet service => /SelectFollower/', err )
   })
}

   var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'

    return (
        <View style={styles.container}>
         
            <ActivityIndicator visible={loading} />
            {followers ===  0 ?
                <FlatList
                  data={items}
                  keyExtractor={(items) => items.userId.toString()}                  
                  renderItem={({ item, index}) => (
                    <ListItem
                    image={profileUri + item.userId + '_' + item.userPhoto}
                    titleRol={item.userName}
                    onPress={ () => {
                         console.log('hola', index)
                         props.navigation.navigate(routes.FOUND_USER, {item, index})
                         }} 
                    >                       
                    </ListItem>   
                  )}>
                </FlatList>
                :
                <Text>
                    This user has not followers             
                </Text>   
            }
        </View>
    );
}

const styles = StyleSheet.create({
    container:{
        flex: 1,
    }
})

export default FollowersScreen;